import { render } from "./FoodRations.vue?vue&type=template&id=441ca934"
import script from "./FoodRations.vue?vue&type=script&lang=js"
export * from "./FoodRations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__